import React from "react";
import { GithubPicker } from "react-color";

export default function ColorPicker(props) {
    return (
        <div
            className="color-box"
            onClick={props.openColorPalette}
            style={{
                backgroundColor: props.color,
            }}
        >
            <div className="hidden" id="color-palette">
                <GithubPicker
                    color={props.color}
                    colors={colors}
                    onChangeComplete={props.handleChangeComplete}
                />
            </div>
        </div>
    );
}
const colors = [
    "#F48418",
    "#FB9301",
    "#FD9B0B",
    "#E4860D",
    "#D1850A",
    "#F4A002",
    "#FDA617",
    "#F8AF0A",
    "#FABE09",
    "#FFE934",
    "#69000F",
    "#8E0E01",
    "#970005",
    "#990B07",
    "#CD0001",
    "#C90E08",
    "#C60205",
    "#D40606",
    "#D20301",
    "#E40A03",
    "#D20300",
    "#D90D07",
    "#DD1603",
    "#F02603",
    "#F02505",
    "#F93E15",
    "#F22E0C",
    "#F74B04",
    "#E93800",
    "#480019",
    "#7E0307",
    "#581045",
    "#44184C",
    "#3B266E",
    "#655194",
    "#B88CB3",
    "#C50B49",
    "#C81356",
    "#D6396C",
    "#EF67A7",
    "#111823",
    "#001836",
    "#0B1536",
    "#0D173C",
    "#002258",
    "#132E5B",
    "#002B6E",
    "#01155B",
    "#051F6E",
    "#032070",
    "#0E237D",
    "#001771",
    "#032799",
    "#011E7C",
    "#003773",
    "#014A6D",
    "#003687",
    "#00489A",
    "#003789",
    "#004E9A",
    "#015BB8",
    "#0053AC",
    "#2F70B9",
    "#026EAD",
    "#0173BC",
    "#0083C8",
    "#1FA6DD",
    "#65879A",
    "#004E72",
    "#01779B",
    "#0093A7",
    "#14C7C6",
    "#68D3E7",
    "#003E23",
    "#004229",
    "#004517",
    "#00541D",
    "#016753",
    "#01703D",
    "#00753F",
    "#007A42",
    "#018454",
    "#008C3C",
    "#009B1B",
    "#4A9D36",
    "#45291E",
    "#422516",
    "#4F331F",
    "#52020E",
    "#B44C17",
    "#6E3510",
    "#9A683F",
    "#9E755A",
    "#DCAE8C",
    "#E4C194",
    "#FAD3A8",
    "#E9D7BD",
    "#ECD8BF",
    "#000000",
    "#2E2F31",
    "#373C3F",
    "#595E61",
    "#616F70",
    "#75828A",
    "#85898C",
    "#8A8F8C",
    "#97999B",
    "#C5C8CB",
    "#DCE2E9",
    "#FFFFFF",
    "#838180",
    "#885D3C",
    "#292F2C",
    "#2D3138",
];
